import { render, staticRenderFns } from "./TransactionConfig.vue?vue&type=template&id=200d34cc&scoped=true&"
import script from "./TransactionConfig.vue?vue&type=script&lang=js&"
export * from "./TransactionConfig.vue?vue&type=script&lang=js&"
import style0 from "./TransactionConfig.vue?vue&type=style&index=0&id=200d34cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d34cc",
  null
  
)

export default component.exports